import { QueryClient } from '@tanstack/react-query';

/**
 * Queue query key utilities
 *
 * We have two query key formats for queue requests:
 * - Legacy (useQueueRequestsQuery): ['queueRequests', status, locationId]
 * - New (useGetQueueRequestsQuery): ['queueRequests', view, requestId, locationId]
 *
 * These helpers ensure consistent invalidation across both formats.
 */

/**
 * Invalidates all queue request queries for a specific location.
 * Targets the new query key format: ['queueRequests', view, requestId, locationId]
 *
 * @param queryClient - The React Query client instance
 * @param locationId - The location ID to invalidate queries for
 */
export const invalidateQueueRequestsForLocation = (queryClient: QueryClient, locationId: string) => {
  queryClient.invalidateQueries({
    predicate: query => {
      const [queryName, , , queryLocationId] = query.queryKey;
      return queryName === 'queueRequests' && queryLocationId === locationId && query.queryKey.length >= 4;
    },
  });
};
